<script lang="ts">
    import { createEventDispatcher } from "svelte"
    const dispatch = createEventDispatcher()
</script>

<button
    class="uploadImage"
    on:click="{() => {
        dispatch('uploadImage')
    }}"
>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M11.47 15.97C11.6106 15.8295 11.8012 15.7507 12 15.7507C12.1988 15.7507 12.3894 15.8295 12.53 15.97L14.53 17.97C14.6037 18.0387 14.6628 18.1215 14.7038 18.2135C14.7448 18.3055 14.7668 18.4048 14.7686 18.5055C14.7704 18.6062 14.7518 18.7062 14.7141 18.7996C14.6764 18.893 14.6203 18.9778 14.549 19.049C14.4778 19.1203 14.393 19.1764 14.2996 19.2141C14.2062 19.2518 14.1062 19.2704 14.0055 19.2686C13.9048 19.2668 13.8055 19.2448 13.7135 19.2038C13.6215 19.1628 13.5387 19.1037 13.47 19.03L12.75 18.31V22.5C12.75 22.6989 12.671 22.8897 12.5303 23.0303C12.3897 23.171 12.1989 23.25 12 23.25C11.8011 23.25 11.6103 23.171 11.4697 23.0303C11.329 22.8897 11.25 22.6989 11.25 22.5V18.31L10.53 19.03C10.4613 19.1037 10.3785 19.1628 10.2865 19.2038C10.1945 19.2448 10.0952 19.2668 9.99452 19.2686C9.89382 19.2704 9.79379 19.2518 9.7004 19.2141C9.60701 19.1764 9.52218 19.1203 9.45096 19.049C9.37974 18.9778 9.3236 18.893 9.28588 18.7996C9.24816 18.7062 9.22963 18.6062 9.23141 18.5055C9.23319 18.4048 9.25523 18.3055 9.29622 18.2135C9.33721 18.1215 9.39631 18.0387 9.47 17.97L11.47 15.97Z"
            fill="#26292C"></path>
        <path
            d="M12.476 4.25C9.726 4.25 7.512 6.45 7.512 9.147C7.512 9.609 7.577 10.056 7.697 10.478C8.194 10.622 8.66 10.838 9.08 11.118C9.16639 11.1703 9.24132 11.2396 9.3003 11.3216C9.35927 11.4036 9.40108 11.4966 9.4232 11.5952C9.44533 11.6938 9.44732 11.7958 9.42906 11.8951C9.41079 11.9944 9.37265 12.0891 9.31692 12.1733C9.26118 12.2576 9.18901 12.3297 9.10472 12.3853C9.02044 12.441 8.92578 12.4791 8.82642 12.4972C8.72706 12.5154 8.62506 12.5133 8.52652 12.4911C8.42799 12.4689 8.33495 12.427 8.253 12.368C7.66992 11.9817 6.98546 11.7767 6.286 11.779C4.325 11.779 2.75 13.349 2.75 15.265C2.75 17.181 4.325 18.75 6.286 18.75C6.48491 18.75 6.67568 18.829 6.81633 18.9697C6.95698 19.1103 7.036 19.3011 7.036 19.5C7.036 19.6989 6.95698 19.8897 6.81633 20.0303C6.67568 20.171 6.48491 20.25 6.286 20.25C3.513 20.25 1.25 18.026 1.25 15.265C1.25 12.56 3.42 10.372 6.114 10.282C6.04614 9.90748 6.012 9.52762 6.012 9.147C6.012 5.606 8.914 2.75 12.476 2.75C15.634 2.75 18.272 4.994 18.831 7.971C21.131 8.948 22.75 11.209 22.75 13.853C22.75 16.927 20.562 19.484 17.657 20.106C17.4625 20.1476 17.2594 20.1103 17.0924 20.0022C16.9254 19.8941 16.8081 19.724 16.7665 19.5295C16.7249 19.335 16.7622 19.1319 16.8703 18.9649C16.9784 18.7979 17.1485 18.6806 17.343 18.639C19.583 18.159 21.25 16.193 21.25 13.853C21.25 11.716 19.86 9.891 17.912 9.225C17.3886 9.04599 16.8392 8.95476 16.286 8.955C15.703 8.955 15.146 9.055 14.628 9.235C14.4414 9.29593 14.2383 9.28126 14.0624 9.19415C13.8865 9.10704 13.7517 8.95443 13.6871 8.76909C13.6224 8.58374 13.633 8.38043 13.7166 8.2028C13.8001 8.02516 13.95 7.88737 14.134 7.819C15.1039 7.48042 16.1401 7.37591 17.158 7.514C16.8085 6.55419 16.1712 5.72564 15.3333 5.14147C14.4953 4.5573 13.4975 4.24597 12.476 4.25Z"
            fill="#26292C"></path>
    </svg>
    <p>Bilder hochladen</p>
</button>

<style lang="less">
    @import "../../../../../assets/variables.less";
    .uploadImage {
        min-height: 333px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 0.6rem;
        border-radius: 12px;
        border: 2px solid var(--grey-200);
        p {
            color: var(--text-100);
        }
        @media @mobile {
            min-height: 74px;
            max-height: 74px;
        }
    }
</style>
